import React from "react";
import PageHeader from "@/components/PageHeader";
import ItemsTable from "@/components/ItemsTable";
import { useDropdownOptions } from "@/hooks/useDropdownOptions";

export default function Artwork() {
  const { owners, artworkStatuses, customerOpts } = useDropdownOptions();

  const columns = [
    { key: "job_name", label: "Job / File", type: "text", required: true, placeholder: "Artwork or file name" },
    { key: "customer_id", label: "Customer", type: "select", options: customerOpts, width: 200 },
    { key: "status", label: "Status", type: "select", options: artworkStatuses, width: 220 },
    { key: "owner", label: "Owner", type: "select", options: owners, width: 140 },
    { key: "file_id", label: "Proof", type: "file", width: 200 },
    { key: "follow_up_date", label: "Follow-up", type: "date", width: 160 },
    { key: "notes", label: "Notes", type: "text" },
  ];

  return (
    <div className="max-w-[1600px] mx-auto px-8 py-10">
      <PageHeader
        eyebrow="Artwork Tracker"
        title="Files & Proofs"
        description="Log missing files, customer approvals, and print-ready art. Follow up before it slows the line."
      />
      <ItemsTable
        endpoint="artwork"
        columns={columns}
        defaultItem={{ job_name: "", customer_id: "", status: "missing", owner: "", notes: "" }}
        testIdPrefix="artwork"
        emptyLabel="No artwork tracked yet."
      />
    </div>
  );
}
